module.exports = __webpack_public_path__ + "static/media/agent-pay-bg.08c8c9bf.png";